export const restUrlsToTrack = [
	{
		api: '/rest/api/3/issue/<id>/comment',
		operationName: 'rest_api_3_issue_<issueid>_comment',
		source: 'src/packages/issue/ai-agent-sessions/src/ui/refinement-session/index.tsx',
	},
	{
		api: '/rest/api/3/issue/<id>/comment',
		operationName: 'rest_api_3_issue_<issueid>_comment',
		source: 'src/packages/issue/ai-agent-sessions/src/ui/refinement-session/index.tsx',
	},
	{
		api: '/gateway/api/assist/ai/v2/',
		operationName: 'gateway_api_assist_ai_v2_<request.ai_feature_path>',
		source:
			'src/packages/issue/ai-improve-issue/ai-assistance-service-client/src/services/ai-features-client/index.tsx',
	},
	{
		api: '/gateway/api/assist/ai/v2/ai-feature/jirasimilarissues',
		operationName: 'gateway_api_assist_ai_v2_ai_feature_jirasimilarissues',
		source:
			'src/packages/issue/ai-improve-issue/ai-related-issues/src/services/use-fetch-related-issues/index.tsx',
	},
	{
		api: '/gateway/api/graphql',
		operationName: 'gateway_api_graphql',
		source:
			'src/packages/issue/ai-related-3p-resources/src/services/use-ai-related-3p-resources.tsx',
	},
	{
		api: '/rest/api/3/issue/<id>/remotelink',
		operationName: 'rest_api_3_issue_<issueid>_remotelink',
		source: 'src/packages/issue/ai-related-3p-resources/src/services/utils.tsx',
	},
	{
		api: '/rest/api/2/issue',
		operationName: 'rest_api_2_issue',
		source: 'src/packages/issue/ai-work-breakdown/src/services/use-bulk-create-issue/utils.tsx',
	},
	{
		api: '/rest/api/3/user/assignable/search?issueKey=<issue-key>&recommend=true&query=',
		operationName: 'rest_api_3_user_assignable_search',
		source: 'src/packages/issue/assignee/src/assignee-view.tsx',
	},
	{
		api: '/rest/api/2/attachment/<uuid>',
		operationName: 'rest_api_2_attachment_<attachmentid>',
		source: 'src/packages/issue/attachments/issue-attachments-store/src/common/utils.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>/remotelink?globalId=<uuid>',
		operationName: 'rest_api_2_issue_<issuekey>_remotelink',
		source: 'src/packages/issue/attachments/issue-attachments-store/src/common/utils.tsx',
	},
	{
		api: '/rest/api/3/issue/<issue-key>/remotelink/<uuid>',
		operationName: 'rest_api_3_issue_<issuekey>_remotelink_<unlinkingremotelinkid>',
		source: 'src/packages/issue/attachments/issue-attachments-store/src/common/utils.tsx',
	},
	{
		api: '/rest/confluenceIssueLink/1/confluence?issueId=<id>',
		operationName: 'rest_confluenceissuelink_1_confluence',
		source: 'src/packages/issue/attachments/issue-attachments-store/src/common/utils.tsx',
	},
	{
		api: '/rest/api/3/issue/<id>/remotelink',
		operationName: 'rest_api_3_issue_<issueid>_remotelink',
		source: 'src/packages/issue/attachments/issue-attachments-store/src/common/utils.tsx',
	},
	{
		api: '/gateway/api/graphql',
		operationName: 'gateway_api_graphql',
		source: 'src/packages/issue/attachments/issue-attachments-store/src/common/utils.tsx',
	},
	{
		api: '/gateway/api/object-resolver/providers?operation=AttachmentsRemoteProviders',
		operationName: 'gateway_api_object_resolver_providers',
		source:
			'src/packages/issue/attachments/issue-attachments-view/src/add-1p/search-1p-dropdown/index.tsx',
	},
	{
		api: '/gateway/api/object-resolver/resolve?operation=AttachmentsResolveLink',
		operationName: 'gateway_api_object_resolver_resolve',
		source:
			'src/packages/issue/attachments/issue-attachments-view/src/add-1p/search-1p-dropdown/index.tsx',
	},
	{
		api: '/rest/api/3/attachment/content/<uuid>',
		operationName: 'rest_api_3_attachment_content_<item.identifier.attachmentid>',
		source:
			'src/packages/issue/attachments/issue-attachments-view/src/grid-view/ui/components/media-card/MediaCardActions.tsx',
	},
	{
		api: '/rest/api/3/attachment/content/<uuid>',
		operationName: 'rest_api_3_attachment_content_<item.identifier.attachmentid>',
		source:
			'src/packages/issue/attachments/issue-attachments-view/src/grid-view/ui/components/media-card/MediaCardActions.tsx',
	},
	{
		api: '/rest/api/latest/attachment/abuse-classification/<id>',
		operationName: 'rest_api_latest_attachment_abuse_classification_<issueid>',
		source:
			'src/packages/issue/attachments/issue-attachments-view/src/heading/meatballs/download-all-item/index.tsx',
	},
	{
		api: '/rest/api/latest/attachment/abuse-classification/<id>',
		operationName: 'rest_api_latest_attachment_abuse_classification_<issueid>',
		source:
			'src/packages/issue/attachments/issue-attachments-view/src/heading/meatballs/download-all-item-with-links/index.tsx',
	},
	{
		api: '/rest/internal/2/issue/<issue-key>/clone',
		operationName: 'rest_internal_2_issue_<issuekey>_clone',
		source: 'src/packages/issue/clone-issue/src/services/clone/index.tsx',
	},
	{
		api: '/rest/api/3/task/<uuid>',
		operationName: 'rest_api_3_task_<taskid>',
		source: 'src/packages/issue/clone-issue/src/services/clone/index.tsx',
	},
	{
		api: '/rest/api/3/issue/<id>?fields=key',
		operationName: 'rest_api_3_issue_<issueid>',
		source: 'src/packages/issue/clone-issue/src/services/clone/index.tsx',
	},
	{
		api: '/rest/internal/2/issue/<issue-key>/clone/meta',
		operationName: 'rest_internal_2_issue_<issuekey>_clone_meta',
		source: 'src/packages/issue/clone-issue/src/services/clone-meta/main.tsx',
	},
	{
		api: '/wiki/rest/api/content',
		operationName: 'wiki_rest_api_content',
		source:
			'src/packages/issue/confluence-content-placeholder-template/src/services/confluence-create-blank-draft.tsx',
	},
	{
		api: '/gateway/api/ex/confluence/<uuid>/wiki/rest/create-dialog/1.0/content/blueprint/<uuid>/instance',
		operationName:
			'gateway_api_ex_confluence_<cloudid>_wiki_rest_create_dialog_1_0_content_blueprint_<blueprintmodulecompletekey>_instance',
		source:
			'src/packages/issue/confluence-content-placeholder-template/src/services/confluence-create-draft.tsx',
	},
	{
		api: '/gateway/api/tap-delivery/api/v3/personalization/site/<uuid>',
		operationName: 'gateway_api_tap-delivery_api_v3_personalization_site<cloudid>',
		source:
			'src/packages/issue/confluence-content-placeholder-template/src/services/fetch-personalization-site-traits.tsx',
	},
	{
		api: '/gateway/api/gcg/api/v1/generate/team_growth/dynamic_placeholder_title',
		operationName: 'gateway_api_gcg_api_v1_generate_team_growth_dynamic_placeholder_title',
		source:
			'src/packages/issue/confluence-content-placeholder-template/src/services/template-text-api.tsx',
	},
	{
		api: '/gateway/api/bxp/signup/product/end-user-activate-eligible-check',
		operationName: 'gateway_api_bxp_signup_product_end_user_activate_eligible_check',
		source:
			'src/packages/issue/confluence-content-placeholder-template/src/services/user-product-permission.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>',
		operationName: 'rest_api_2_issue_<issuekey>',
		source: 'src/packages/issue/context-fields/components/index.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>',
		operationName: 'rest_api_2_issue_<issuekey>',
		source: 'src/packages/issue/context-fields/components/index.tsx',
	},
	{
		api: '/rest/servicedesk/1/servicedesk/request/<id>/request-types?query=',
		operationName: 'rest_servicedesk_1_servicedesk_request_<issueid>_request_types',
		source: 'src/packages/issue/context-fields/customer-request-type/index.tsx',
	},
	{
		api: '/rest/api/2/groups/picker',
		operationName: 'rest_api_2_groups_picker',
		source: 'src/packages/issue/context-fields/group-picker/rest/fetch.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>',
		operationName: 'rest_api_2_issue_<issuekey>',
		source: 'src/packages/issue/context-fields/labels/index.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>',
		operationName: 'rest_api_2_issue_<issuekey>',
		source: 'src/packages/issue/context-fields/labels/index.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>',
		operationName: 'rest_api_2_issue_<issuekey>',
		source: 'src/packages/issue/context-fields/multi-select-with-relay-edit-view/index.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>',
		operationName: 'rest_api_2_issue_<issuekey>',
		source: 'src/packages/issue/context-fields/multi-select-with-relay-edit-view/index.tsx',
	},
	{
		api: '/rest/api/3/user/recommend',
		operationName: 'rest_api_3_user_recommend',
		source: 'src/packages/issue/context-fields/multi-user/index.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>',
		operationName: 'rest_api_2_issue_<issuekey>',
		source: 'src/packages/issue/context-fields/single-select-with-relay-edit-view/index.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>',
		operationName: 'rest_api_2_issue_<issuekey>',
		source: 'src/packages/issue/context-fields/single-select-with-relay-edit-view/index.tsx',
	},
	{
		api: '/gateway/api/ex/confluence/<uuid>/wiki/rest/api/content/<uuid>?status=draft',
		operationName: 'gateway_api_ex_confluence_<cloudid>_wiki_rest_api_content_<pageid>',
		source:
			'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx',
	},
	{
		api: '/gateway/api/invitations/v1/access-requests/capabilities',
		operationName: '<conf_request_access_capabilities_url>',
		source:
			'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx',
	},
	{
		api: '/gateway/api/invitations/v1/access-requests/request',
		operationName: '<conf_direct_join_api>',
		source:
			'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx',
	},
	{
		api: '/gateway/api/ex/confluence/<uuid>/wiki/rest/api/user/current?expand=operations',
		operationName: 'gateway_api_ex_confluence_<cloudid>_wiki_rest_api_user_current',
		source:
			'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx',
	},
	{
		api: '/gateway/api/ex/confluence/<uuid>/wiki/rest/api/user/current?expand=personalSpace',
		operationName: 'gateway_api_ex_confluence_<cloudid>_wiki_rest_api_user_current',
		source:
			'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx',
	},
	{
		api: '/gateway/api/ex/confluence/<uuid>/wiki/api/v2/pages',
		operationName: 'gateway_api_ex_confluence_<cloudid>_wiki_api_v2_pages',
		source:
			'src/packages/issue/create-confluence-content/src/services/confluence-rest-api/index.tsx',
	},
	{
		api: '/gateway/api/permissions/permitted',
		operationName: 'gateway_api_permissions_permitted',
		source: 'src/packages/issue/create-confluence-content/src/services/permissions/index.tsx',
	},
	{
		api: '/gateway/api/ex/confluence',
		operationName: 'gateway_api_ex_confluence',
		source:
			'src/packages/issue/create-confluence-content/src/ui/background-provisioning-editor/provisioning-api.tsx',
	},
	{
		api: '/gateway/api/xflow/provision/cloud',
		operationName: 'gateway_api_xflow_provision_cloud',
		source:
			'src/packages/issue/create-confluence-content/src/ui/background-provisioning-editor/provisioning-api.tsx',
	},
	{
		api: '/rest/api/3/issue/<issue-key>',
		operationName: 'rest_api_3_issue_<issuekey>',
		source: 'src/packages/issue/description-field/src/description/view.tsx',
	},
	{
		api: '/rest/api/2/issue/<id>/properties/<id>',
		operationName: 'rest_api_2_issue_<issueid>_properties_<last_viewed_issue_property_key>',
		source:
			'src/packages/issue/designs/design-section/src/services/set-last-viewed-issue-property/index.tsx',
	},
	{
		api: '/rest/api/3/issue/<issue-key>',
		operationName: 'rest_api_3_issue_<issuekey>',
		source:
			'src/packages/issue/ecosystem-issue-view/src/forge/custom-field/formatter-value/index.tsx',
	},
	{
		api: '/rest/internal/latest/project-access/access-requested',
		operationName: 'rest_internal_latest_project_access_access_requested',
		source: 'src/packages/issue/errors/src/services/request-access-service.tsx',
	},
	{
		api: '/rest/api/3/task/<uuid>',
		operationName: 'rest_api_3_task_<taskid>',
		source: 'src/packages/issue/export-excel-dialog/src/ui/task-poll-manager.tsx',
	},
	{
		api: '/rest/issues/latest/export/<uuid>',
		operationName: 'rest_issues_latest_export_<taskid>',
		source: 'src/packages/issue/export-excel-dialog/src/ui/utils.tsx',
	},
	{
		api: '/rest/api/3/user',
		operationName: 'rest_api_3_user',
		source: 'src/packages/issue/feedback-button/src/view/feedback-button/button.tsx',
	},
	{
		api: '/rest/assetinternalapi/latest/field/<id>/config',
		operationName: 'rest_assetinternalapi_latest_field_<customfieldid>_config',
		source: 'src/packages/issue/fields/assets/src/ui/edit/utils.tsx',
	},
	{
		api: '/rest/api/3/issue/<issue-key>?fields=assignee',
		operationName: 'rest_api_3_issue_<issuekey>',
		source: 'src/packages/issue/fields/assignee/src/services/use-assignee-field/index.tsx',
	},
	{
		api: '/rest/internal/2/userteam/mention/search',
		operationName: 'rest_internal_2_userteam_mention_search',
		source:
			'src/packages/issue/fields/platform/text-area/editview-full/src/ui/text-area/utils/use-text-area-mention-provider/text-area-mention-provider/index.tsx',
	},
	{
		api: '/rest/api/3/issue/<issue-key>/',
		operationName: 'rest_api_3_issue_<issuekey>',
		source:
			'src/packages/issue/fields/service-entity/src/common/ui/collapsible-field/use-collapsible-field/index.tsx',
	},
	{
		api: '/rest/servicedesk/cmdb/latest/object/<uuid>',
		operationName: 'rest_servicedesk_cmdb_latest_object_<workspaceandobjectid>',
		source:
			'src/packages/issue/fields/service-entity/src/services/fetch-object-details/fetch-object-details/index.tsx',
	},
	{
		api: '/rest/service-registry-api/service?query=',
		operationName: 'rest_service_registry_api_service',
		source:
			'src/packages/issue/fields/service-entity/src/services/resolve-field-values-by-id/index.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>/transitions?sortByOpsBarAndStatus=true',
		operationName: 'rest_api_2_issue_<issuekey>_transitions',
		source: 'src/packages/issue/fields/status/src/services/status-transitions-service/index.tsx',
	},
	{
		api: '/rest/api/3/issue/<issue-key>?fields=creator,created',
		operationName: 'rest_api_3_issue_<issuekey>',
		source:
			'src/packages/issue/issue-actions/issue-history/src/services/issue-history/history-item-generator/index.tsx',
	},
	{
		api: '/rest/api/3/issue/picker?currentIssueKey=<issue-key>&currentProjectId=<id>&showSubTasks=true&showSubTaskParent=true',
		operationName: 'rest_api_3_issue_picker',
		source: 'src/packages/issue/issue-picker/src/services/options/main.tsx',
	},
	{
		api: '/rest/greenhopper/1.0/xboard/work/media?issueIds=<id>',
		operationName: 'rest_greenhopper_1_0_xboard_work_media',
		source: 'src/packages/issue/issue-view-app-provider/src/epics/card-cover-fetch-epic.tsx',
	},
	{
		api: '/rest/greenhopper/1.0/xboard/work/additionalBoardData?rapidViewId=<id>',
		operationName: 'rest_greenhopper_1_0_xboard_work_additionalboarddata',
		source: 'src/packages/issue/issue-view-app-provider/src/epics/card-cover-fetch-epic.tsx',
	},
	{
		api: "/rest/api/2/issue/<issue-key>/comment/<uuid>` : ''}",
		operationName: 'rest_api_2_issue_<issuekey>_comment_<commentid>',
		source: 'src/packages/issue/issue-view-app-provider/src/epics/comment-delete-epic.tsx',
	},
	{
		api: '/rest/internal/issue/<id>/comment/<uuid>/pin',
		operationName: 'rest_internal_issue_<issueid>_comment_<commentid>_pin',
		source: 'src/packages/issue/issue-view-app-provider/src/epics/comment-save-epic.tsx',
	},
	{
		api: '/gateway/api/ex/confluence/<uuid>/wiki/rest/recentlyviewed/1.0/recent',
		operationName: 'gateway_api_ex_confluence_<cloudid>_wiki_rest_recentlyviewed_1_0_recent',
		source:
			'src/packages/issue/issue-view-app-provider/src/epics/fetch-recently-visited-confluence-pages-stargate.tsx',
	},
	{
		api: '/rest/internal/2/project/<project-key>/hasValidatorsOnSubtasks',
		operationName: 'rest_internal_2_project_<projectkey>_hasvalidatorsonsubtasks',
		source: 'src/packages/issue/issue-view-app-provider/src/epics/project-validator-server.tsx',
	},
	{
		api: '/rest/internal/2/issue/<issue-key>/history',
		operationName: 'rest_internal_2_issue_<issuekey>_history',
		source: 'src/packages/issue/issue-view-app-provider/src/epics/recently-viewed-issue-epic.tsx',
	},
	{
		api: '/rest/api/3/issue/<id>/remotelink',
		operationName: 'rest_api_3_issue_<issueid>_remotelink',
		source: 'src/packages/issue/issue-view-app-provider/src/epics/web-links-server.tsx',
	},
	{
		api: '/rest/api/3/issue/<issue-key>/remotelink/<id>',
		operationName: 'rest_api_3_issue_<issuekey>_remotelink_<id>',
		source: 'src/packages/issue/issue-view-app-provider/src/epics/web-links-server.tsx',
	},
	{
		api: '/rest/api/2/attachment/upload/issue/<issue-key>/credentials',
		operationName: 'rest_api_2_attachment_upload_issue_<issuekey>_credentials',
		source:
			'src/packages/issue/issue-view-common-media/src/upload-context/upload-context-server.tsx',
	},
	{
		api: '/rest/api/3/mypreferences',
		operationName: 'rest_api_3_mypreferences',
		source:
			'src/packages/issue/issue-view-product-templates/components/layout-group/src/services/group-preferences/user-preferences/use-group-user-preferences.tsx',
	},
	{
		api: '/rest/api/3/mypreferences',
		operationName: 'rest_api_3_mypreferences',
		source:
			'src/packages/issue/issue-view-product-templates/services/src/services/context/visible-hidden/hide-empty-fields/user-preferences/index.tsx',
	},
	{
		api: '/rest/api/3/issue/<issue-key>?deleteSubtasks=true',
		operationName: 'rest_api_3_issue_<issuekey>',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-delete-server.tsx',
	},
	{
		api: '/rest/internal/simplified/1.0/projects/<id>/issues//children',
		operationName: 'rest_internal_simplified_1_0_projects_<projectid>_issues_<parentid>_children',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-parent-server.tsx',
	},
	{
		api: '/rest/internal/simplified/1.0/projects/<id>/issues/delete-parents',
		operationName: 'rest_internal_simplified_1_0_projects_<projectid>_issues_delete_parents',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-parent-server.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>',
		operationName: 'rest_api_2_issue_<issuekey>',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/api/2/search/jql',
		operationName: 'rest_api_2_search_jql',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/api/2/search/jql',
		operationName: 'rest_api_2_search_jql',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>?fields=issuelinks',
		operationName: 'rest_api_2_issue_<issuekey>',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>',
		operationName: 'rest_api_2_issue_<issuekey>',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/api/2/issueLinkType',
		operationName: 'rest_api_2_issuelinktype',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/api/2/issue/picker?currentIssueKey=<issue-key>&showSubTasks=true&showSubTaskParent=true',
		operationName: 'rest_api_2_issue_picker',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/api/2/issue/createmeta?projectKeys=<project-key>&expand=projects.issuetypes.fields',
		operationName: 'rest_api_2_issue_createmeta',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/api/2/issueLink',
		operationName: 'rest_api_2_issuelink',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/remoteJiraIssueLink/1/remoteJira/<issue-key>/createIssueLink',
		operationName: 'rest_remotejiraissuelink_1_remotejira_<currentissueidorkey>_createissuelink',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/confluenceIssueLink/1/confluence/applink',
		operationName: 'rest_confluenceissuelink_1_confluence_applink',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/issueLinkAppLink/1/appLink/info?type=com.atlassian.applinks.api.application.jira.JiraApplicationType&issueIdOrKey=<issue-key>',
		operationName: 'rest_issuelinkapplink_1_applink_info',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/remoteJiraIssueLink/1/remoteJira/picker?showSubTasks=true&showSubTaskParent=true',
		operationName: 'rest_remotejiraissuelink_1_remotejira_picker',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/remoteJiraIssueLink/1/remoteJira/picker',
		operationName: 'rest_remotejiraissuelink_1_remotejira_picker',
		source: 'src/packages/issue/issue-view-services/src/issue/issue-urls.tsx',
	},
	{
		api: '/rest/api/3/issue/<issue-key>/remotelink',
		operationName: 'rest_api_3_issue_<issuekey>_remotelink',
		source: 'src/packages/issue/issue-view-services/src/issue/remote-issue-link-delete-server.tsx',
	},
	{
		api: '/rest/servicedesk/lingo-integration/1/request-language/<id>',
		operationName: 'rest_servicedesk_lingo_integration_1_request_language_<issueid>',
		source: 'src/packages/issue/issue-view-services/src/issue/request-language-server.tsx',
	},
	{
		api: '/rest/internal/2/userteam/mention/search',
		operationName: 'rest_internal_2_userteam_mention_search',
		source:
			'src/packages/issue/issue-view-services/src/mentions/issue-user-team-mention-provider-next.tsx',
	},
	{
		api: '/rest/internal/2/userteam/mention/search',
		operationName: 'rest_internal_2_userteam_mention_search',
		source:
			'src/packages/issue/issue-view-services/src/mentions/issue-user-team-mention-provider.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>/properties/<id>',
		operationName: 'rest_api_2_issue_<issuekey>_properties_<addonmodulekey>',
		source: 'src/packages/issue/issue-view-store/src/ecosystem/ecosystem-extension-add-server.tsx',
	},
	{
		api: '/rest/api/2/issue/<issue-key>/properties/<id>',
		operationName: 'rest_api_2_issue_<issuekey>_properties_<extensionid>',
		source: 'src/packages/issue/issue-view-store/src/ecosystem/forge/forge-extension-server.tsx',
	},
	{
		api: '/rest/internal/simplified/1.0/projects/<id>/issues/delete-parents',
		operationName: 'rest_internal_simplified_1_0_projects_<projectid>_issues_delete_parents',
		source: 'src/packages/issue/parent-services/src/services/rest/delete/team-managed/index.tsx',
	},
	{
		api: '/rest/internal/simplified/1.0/projects/<id>/issues//children',
		operationName: 'rest_internal_simplified_1_0_projects_<projectid>_issues_<parentid>_children',
		source: 'src/packages/issue/parent-services/src/services/rest/set/team-managed/index.tsx',
	},
	{
		api: '/gateway/api/assist/api/ai/v2/ai-feature/proactive/jira',
		operationName: 'gateway_api_assist_api_ai_v2_ai_feature_proactive_jira',
		source:
			'src/packages/issue/smart-request-summary/request-summary-state/src/controllers/state/actions/index.tsx',
	},
	{
		api: '/gateway/api/assist/api/ai/v2/ai-feature/proactive/jira/dismiss',
		operationName: 'gateway_api_assist_api_ai_v2_ai_feature_proactive_jira_dismiss',
		source:
			'src/packages/issue/smart-request-summary/request-summary-state/src/controllers/state/actions/index.tsx',
	},
	{
		api: '/gateway/api/assist/api/ai/v2/ai-feature/jira/comment-summary/followups',
		operationName: 'gateway_api_assist_api_ai_v2_ai_feature_jira_comment_summary_followups',
		source:
			'src/packages/issue/smart-request-summary/request-summary-state/src/services/follow-ups/index.tsx',
	},
	{
		api: '/rest/greenhopper/3/xboard/issue/flag/flag',
		operationName: 'rest_greenhopper_3_xboard_issue_flag_flag',
		source: 'src/packages/issue/status/src/flagged-field-popup/services/save-flag-with-comment.tsx',
	},
	{
		api: '/rest/api/3/issue/<issue-key>',
		operationName: 'rest_api_3_issue_<issuekey>',
		source: 'src/packages/issue/switching-multiline-field/src/view.tsx',
	},
	{
		api: '/gateway/api/third-party-configuration/connected-data-sources/<uuid>',
		operationName: 'gateway_api_third_party_configuration_connected_data_sources_<cloudid>',
		source:
			'src/packages/issue/third-party-connected-data-sources/src/services/fetch-third-party-connectors/index.tsx',
	},
	{
		api: '/rest/servicedesk/1/servicedesk/sla/issue/<issue-key>',
		operationName: 'rest_servicedesk_1_servicedesk_sla_issue_<issuekey>',
		source: 'src/packages/router-resources/jsm-issue-view/src/services/index.tsx',
	},
	{
		api: '/rest/gira/1/?',
		operationName: 'rest_gira_1',
		source:
			'src/packages/router-resources/offering-catalogue-features/src/controllers/get-data/index.tsx',
	},
	{
		api: '/rest/api/3/project/<project-key>/properties/<id>',
		operationName: 'rest_api_3_project_<projectidorkey>_properties_<entitykey>',
		source:
			'src/packages/router-resources/project-global-components/src/services/get-data/index.tsx',
	},
	{
		api: '/rest/api/3/project/<project-key>',
		operationName: 'rest_api_3_project_<projectkey>',
		source:
			'src/packages/router-resources/project-global-components/src/services/get-data/index.tsx',
	},
];
